import * as React from 'react';

const defaultRoutingContextValue = [
    {
        goTo: ()=>null
    },
    {
        component: undefined,
        queryParams: {},
        currentRoute: '',
        basePath: ''
    }, 
];
const RoutingContext = /*#__PURE__*/ React.createContext(defaultRoutingContextValue);
const useRoutingContext = ()=>React.useContext(RoutingContext)
;

export { RoutingContext, defaultRoutingContextValue, useRoutingContext };
//# sourceMappingURL=context.js.map
